import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Text } from '@rsos/components/capstone/base';
import { ACTIVE, DEACTIVATED } from '@rsos/constants/peerAgenciesStatuses';
import { agencyStatusMap } from '../../utils/helpers';
import AgencyStatusToggle from '../AgencyStatusToggle';
import { TableRow } from '../LinksToTable/LinksToTable.styles';

const LinksFromRow = () => {
  const agencyLinksFrom = useSelector(
    state => state.peerAgencies.agencyLinks.linksFrom,
  );

  return agencyLinksFrom && agencyLinksFrom.length ? (
    agencyLinksFrom.map(agency =>
      agency.status === ACTIVE || agency.status === DEACTIVATED ? (
        <TableRow data-name="links-from-row" key={agency.id}>
          <Box width="50%">
            <Text
              size="normal"
              color={agency.status === ACTIVE ? 'primaryText' : 'secondaryText'}
              ellipsis
            >
              {agency.link_from.display_name}
            </Text>
          </Box>
          <Box width="50%">
            {agency.status === ACTIVE || agency.status === DEACTIVATED ? (
              <AgencyStatusToggle agency={agency} />
            ) : (
              <Text size="normal" color={'secondaryText'}>
                {agencyStatusMap(agency.status)}
              </Text>
            )}
          </Box>
        </TableRow>
      ) : null,
    )
  ) : (
    <Text color="secondaryText" data-name="no-peer-agencies">
      There are no peer agencies.
    </Text>
  );
};

export default LinksFromRow;
